import { render } from "./Configuration.vue?vue&type=template&id=2aadb478&scoped=true&ts=true"
import script from "./Configuration.vue?vue&type=script&lang=ts"
export * from "./Configuration.vue?vue&type=script&lang=ts"

import "./Configuration.vue?vue&type=style&index=0&id=2aadb478&lang=scss&scoped=true"

import exportComponent from "C:\\agentcloudALProd\\_work\\12\\s\\AEL.NominaElectronica.Web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aadb478"]])

export default __exports__